export default "__VITE_ASSET__DKwyq5Kp__"